import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "p-mb-3" }
const _hoisted_3 = { class: "p-mb-3" }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "p-p-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, "arayachoothong@gmail.com")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "p-p-2" }, [
  /*#__PURE__*/_createElementVNode("div", null, "000-000-0000")
], -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputTextCustom = _resolveComponent("InputTextCustom")!
  const _component_Panel = _resolveComponent("Panel")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_Panel, {
      header: "ช่องทางการติดต่อกลับ",
      toggleable: _ctx.isDisplay,
      collapsed: _ctx.isCollapsed,
      "onUpdate:collapsed": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.isCollapsed) = $event))
    }, _createSlots({
      default: _withCtx(() => [
        (!_ctx.isDisplay)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_InputTextCustom, {
                  "model-value": _ctx.form.email,
                  textFloat: "อีเมล",
                  placeholder: "อีเมล",
                  type: "text",
                  name: "email",
                  maxlength: 10,
                  isRequired: "",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.email = $event)),
                  class: "f-regular"
                }, null, 8, ["model-value"])
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_InputTextCustom, {
                  "model-value": _ctx.form.telephone,
                  textFloat: "หมายเลขโทรศัพท์",
                  placeholder: "หมายเลขโทรศัพท์",
                  oninput: "if( this.value.length > 10 )  this.value = this.value.slice(0,10)",
                  type: "number",
                  name: "telephone",
                  inputmode: "numeric",
                  isRequired: "",
                  "onUpdate:modelValue": _ctx.handlerZipcode,
                  class: "f-regular"
                }, null, 8, ["model-value", "onUpdate:modelValue"])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
      ]),
      _: 2
    }, [
      (_ctx.isDisplay)
        ? {
            name: "icons",
            fn: _withCtx(() => [
              (!_ctx.isCollapsed)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: "pi pi-chevron-up",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isCollapsed = !_ctx.isCollapsed))
                  }))
                : _createCommentVNode("", true),
              (_ctx.isCollapsed)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 1,
                    class: "pi pi-chevron-down",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isCollapsed = !_ctx.isCollapsed))
                  }))
                : _createCommentVNode("", true)
            ]),
            key: "0"
          }
        : undefined
    ]), 1032, ["toggleable", "collapsed"])
  ]))
}